export const RU_HOSTS = new Set(['egabetz.com']);

export const PROOM_LOBBY_URL = RU_HOSTS.has(window.location.hostname)
    ? `https://poker.${window.location.hostname}/lobby/`
    : 'https://poker.egb.net/lobby/';

export const PROOM_ORIGIN = new URL(PROOM_LOBBY_URL).origin;

export const PROOM_CENTRIFUGO_PATH = '/connection/websocket';

export const ISO_DATE_LENGTH = 10;

export const DESKTOP_FIT_VALUE = '1';

export const MOBILE_FIT_VALUE = '0';

export interface BuildLobbySrcParams {
    externalId: string
    nickname: string
    userToken: string
    parentOrigin: string
    playerProfilesToken: string
    playerProfilesBaseUrl: string
    fit: string
    lang: string
    mode: 'lobby' | 'full-lobby'
    tournamentId?: string
}

export interface BuildTableSrcParams {
    boardId: string
    externalId: string
    nickname: string
    userToken: string
    parentOrigin: string
    playerProfilesToken: string
    playerProfilesBaseUrl: string
    fit: string
    lang: string
}

export const buildLobbySrc = (params: BuildLobbySrcParams): string => {
    const urlParams = new URLSearchParams({
        _v: new Date().toISOString().slice(0, ISO_DATE_LENGTH),
        centrifugoUrl: PROOM_CENTRIFUGO_PATH,
        embeddedInWidget: 'true',
        externalId: params.externalId,
        fit: params.fit,
        lang: params.lang,
        mode: params.mode,
        nickname: params.nickname,
        parentOrigin: params.parentOrigin,
        playerProfilesToken: params.playerProfilesToken,
        playerProfilesUrl: `${params.playerProfilesBaseUrl}/poker/player_profiles`,
        userToken: params.userToken
    });

    if (params.mode === 'full-lobby' && params.tournamentId) {
        urlParams.set('tournamentId', params.tournamentId);
    }

    return `${PROOM_LOBBY_URL}?${urlParams.toString()}`;
};

export const buildTableSrc = (params: BuildTableSrcParams): string => {
    const urlParams = new URLSearchParams({
        _v: new Date().toISOString().slice(0, ISO_DATE_LENGTH),
        boardId: params.boardId,
        centrifugoUrl: PROOM_CENTRIFUGO_PATH,
        embeddedInWidget: 'true',
        externalId: params.externalId,
        fit: params.fit,
        lang: params.lang,
        nickname: params.nickname,
        parentOrigin: params.parentOrigin,
        playerProfilesToken: params.playerProfilesToken,
        playerProfilesUrl: `${params.playerProfilesBaseUrl}/poker/player_profiles`,
        userToken: params.userToken
    });

    return `${PROOM_LOBBY_URL}?${urlParams.toString()}`;
};
